import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationDynamicButtonHttpResponse, INotificationDynamicLinkHttpResponse, INotificationEventEndpointEmailHttpResponse, INotificationEventEndpointFirebaseHttpResponse, INotificationEventEndpointHttpResponse, INotificationEventEndpointTaskHttpResponse, NotificationEventEndpoint, NotificationEventEndpointEmail, NotificationEventEndpointFirebase, NotificationEventEndpointTask } from '@app/models/notification-settings';
import { map, Observable } from 'rxjs';

const HttpServiceMethods = {
  NotificationEventEndpoint: 'NotificationEventEndpoints',
  GetNotificationEventEndpoints: 'NotificationEventEndpoint/GetNotificationEventEndpoints',
  GetNotificationEventEndpointDynamicButtons: 'NotificationEventEndpoint/GetNotificationEventEndpointDynamicButtons',
  GetNotificationEventEndpointDynamicLinks: 'NotificationEventEndpoint/GetNotificationEventEndpointDynamicLinks',
  GetNotificationEventEndpointEmail: 'NotificationEventEndpoint/GetNotificationEventEndpointEmail',
  SaveNotificationEventEndpointEmail: 'NotificationEventEndpoint/SaveNotificationEventEndpointEmail',
  SaveNotificationEventEndpointFireBase: 'NotificationEventEndpoint/SaveNotificationEventEndpointFireBase',
  GetNotificationEventEndpointFireBase: 'NotificationEventEndpoint/GetNotificationEventEndpointFireBase',
  SaveNotificationEventEndpointTask: 'NotificationEventEndpoint/SaveNotificationEventEndpointTask',
  GetNotificationEventEndpointTask: 'NotificationEventEndpoint/GetNotificationEventEndpointTask'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationEventEndpointsService {

  constructor(private httpService: HttpCallService) { }

  public list(notificationEventId: number): Observable<NotificationEventEndpoint[]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpoints}/${notificationEventId}`)
      .pipe(
        map((res) => res.map((item: INotificationEventEndpointHttpResponse) => NotificationEventEndpoint.adapt(item)))
      );
  }

  getEndpointDynamicButtons(notificationEventId: number, notificationEventEndPointType: number): Observable<[INotificationDynamicButtonHttpResponse]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpointDynamicButtons}/${notificationEventId}/${notificationEventEndPointType}`);
  }

  getEndpointDynamicLinks(notificationEventId: number, notificationEventEndPointType: number): Observable<[INotificationDynamicLinkHttpResponse]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpointDynamicLinks}/${notificationEventId}/${notificationEventEndPointType}`);
  }

  getNotificationEventEndpointEmail(notificationEventEndPointId: number): Observable<[NotificationEventEndpointEmail]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpointEmail}/${notificationEventEndPointId}`)
      .pipe(
        map((res) => res.map((item: INotificationEventEndpointEmailHttpResponse) => NotificationEventEndpointEmail.adapt(item)))
      );
  }
  
  SaveNotificationEventEndpointEmail(notificationEventEndpointEmail: NotificationEventEndpointEmail) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SaveNotificationEventEndpointEmail,
      notificationEventEndpointEmail
    );
  }
  
  getNotificationEventEndpointFirebase(notificationEventEndPointId: number): Observable<[NotificationEventEndpointFirebase]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpointFireBase}/${notificationEventEndPointId}`)
      .pipe(
        map((res) => res.map((item: INotificationEventEndpointFirebaseHttpResponse) => NotificationEventEndpointFirebase.adapt(item)))
      );
  }
  
  SaveNotificationEventEndpointFirebase(notificationEventEndpointFirebase: NotificationEventEndpointFirebase) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SaveNotificationEventEndpointFireBase,
      notificationEventEndpointFirebase
    );
  }
  
  getNotificationEventEndpointTask(notificationEventEndPointId: number): Observable<[NotificationEventEndpointTask]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationEventEndpointTask}/${notificationEventEndPointId}`)
      .pipe(
        map((res) => res.map((item: INotificationEventEndpointTaskHttpResponse) => NotificationEventEndpointTask.adapt(item)))
      );
  }
  
  SaveNotificationEventEndpointTask(notificationEventEndpointTask: NotificationEventEndpointTask) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.SaveNotificationEventEndpointTask,
      notificationEventEndpointTask
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.NotificationEventEndpoint + `/${id}`
    );
  }
}
